// data/languages/swahili/categories/nombres.ts

import { CategoryData } from '../../../../types/types';

export {};

export const nombres: CategoryData = {
  'Sifuri': { translation: 'Zéro', translationEn: 'Zero', audio: 'Sw-sifuri', illustration: '0' },
  'Moja': { translation: 'Un', translationEn: 'One', audio: 'Sw-moja', illustration: '1️⃣' },
  'Mbili': { translation: 'Deux', translationEn: 'Two', audio: 'Sw-mbili', illustration: '2️⃣' },
  'Tatu': { translation: 'Trois', translationEn: 'Three', audio: 'Sw-tatu', illustration: '3️⃣' },
  'Nne': { translation: 'Quatre', translationEn: 'Four', audio: 'Sw-nne', illustration: '4️⃣' },
  'Tano': { translation: 'Cinq', translationEn: 'Five', audio: 'Sw-tano', illustration: '5️⃣' },
  'Sita': { translation: 'Six', translationEn: 'Six', audio: 'Sw-sita', illustration: '6️⃣' },
  'Saba': { translation: 'Sept', translationEn: 'Seven', audio: 'Sw-saba', illustration: '7️⃣' },
  'Nane': { translation: 'Huit', translationEn: 'Eight', audio: 'Sw-nane', illustration: '8️⃣' },
  'Tisa': { translation: 'Neuf', translationEn: 'Nine', audio: 'Sw-tisa', illustration: '9️⃣' },
  'Kumi': { translation: 'Dix', translationEn: 'Ten', audio: 'Sw-kumi', illustration: '🔟' },

  'Kumi na moja': { translation: 'Onze', translationEn: 'Eleven', illustration: '1️⃣1️⃣' },
  'Kumi na mbili': { translation: 'Douze', translationEn: 'Twelve', illustration: '1️⃣2️⃣' },
  'Kumi na tatu': { translation: 'Treize', translationEn: 'Thirteen', illustration: '1️⃣3️⃣' },
  'Kumi na nne': { translation: 'Quatorze', translationEn: 'Fourteen', illustration: '1️⃣4️⃣' },
  'Kumi na tano': { translation: 'Quinze', translationEn: 'Fifteen', illustration: '1️⃣5️⃣' },
  'Kumi na sita': { translation: 'Seize', translationEn: 'Sixteen', illustration: '1️⃣6️⃣' },
  'Kumi na saba': { translation: 'Dix-sept', translationEn: 'Seventeen', illustration: '1️⃣7️⃣' },
  'Kumi na nane': { translation: 'Dix-huit', translationEn: 'Eighteen', illustration: '1️⃣8️⃣' },
  'Kumi na tisa': { translation: 'Dix-neuf', translationEn: 'Nineteen', illustration: '1️⃣9️⃣' },

  'Ishirini': { translation: 'Vingt', translationEn: 'Twenty', audio: 'Sw-ishirini', illustration: '2️⃣0️⃣' },
  'Ishirini na moja': { translation: 'Vingt-et-un', translationEn: 'Twenty-one', illustration: '2️⃣1️⃣' },


  'Thelathini': { translation: 'Trente', translationEn: 'Thirty', illustration: '3️⃣0️⃣' },
  'Thelathini na moja': { translation: 'Trente-et-un', translationEn: 'Thirty-one', illustration: '3️⃣1️⃣' },

  'Arobaini': { translation: 'Quarante', translationEn: 'Forty', audio: 'Sw-arobaini', illustration: '4️⃣0️⃣' },
  'Arobaini na moja': { translation: 'Quarante-et-un', translationEn: 'Forty-one', illustration: '4️⃣1️⃣' },

  'Hamsini': { translation: 'Cinquante', translationEn: 'Fifty', audio: 'Sw-hamsini', illustration: '5️⃣0️⃣' },
  'Hamsini na moja': { translation: 'Cinquante-et-un', translationEn: 'Fifty-one', illustration: '5️⃣1️⃣' },

  'Sitini': { translation: 'Soixante', translationEn: 'Sixty', audio: 'Sw-sitini', illustration: '6️⃣0️⃣' },
  'Sitini na moja': { translation: 'Soixante-et-un', translationEn: 'Sixty-one', illustration: '6️⃣1️⃣' },

  'Sabini': { translation: 'Soixante-dix', translationEn: 'Seventy', illustration: '7️⃣0️⃣' },
  'Sabini na moja': { translation: 'Soixante-et-onze', translationEn: 'Seventy-one', illustration: '7️⃣1️⃣' },

  'Themanini': { translation: 'Quatre-vingts', translationEn: 'Eighty', audio: 'Sw-themanini', illustration: '8️⃣0️⃣' },
  'Themanini na moja': { translation: 'Quatre-vingt-un', translationEn: 'Eighty-one', illustration: '8️⃣1️⃣' },

  'Tisini': { translation: 'Quatre-vingt-dix', translationEn: 'Ninety', audio: 'Sw-tisini', illustration: '9️⃣0️⃣' },
  'Tisini na moja': { translation: 'Quatre-vingt-onze', translationEn: 'Ninety-one', illustration: '9️⃣1️⃣' },

  'Mia': { translation: 'Cent', translationEn: 'Hundred', audio: 'Sw-mia', illustration: '💯' },


  'Elfu': { translation: 'Mille', translationEn: 'Thousand', audio: 'Sw-elfu', illustration: '1️⃣0️⃣0️⃣0️⃣' },

  'Elfu kumi': { translation: 'Dix mille', translationEn: 'Ten thousand', audio: 'Sw-elfu_kumi', illustration: '1️⃣0️⃣0️⃣0️⃣0️⃣' },
  'Elfu mia': { translation: 'Cent mille', translationEn: 'Hundred thousand', audio: 'Sw-elfu_mia', illustration: '1️⃣0️⃣0️⃣0️⃣0️⃣0️⃣' },


};

export default nombres;
export {};
